<template>
  <div class="step step--temperature-interactive temperature-interactive heating-process">
    <div class="temperature-interactive__text" >
      <template v-if="heatingNumber < heatingEnd"><span v-html="$t('temperatureIncrease.title')"></span></template>
      <template v-else><span v-html="$t('temperatureIncrease.titleReady')"></span></template>
    </div>

    <div
        class="heating-process__controls rounded-box"
        @click="increaseHeating"
    >
      <div class="heating-process__numbers text-numeric text-shadow"
           :class="{'heating-process__numbers--green': heatingNumber > 0}"
      >
        <span v-if="heatingNumber > -1">+</span>{{ heatingNumber }} <span class="text-nova text-shadow">°</span>
      </div>

      <div class="heating-process__arrows">
        <div class="arrow arrow--active">
          <img src="@/assets/img/chevron_up.svg" alt="svg">
        </div>
        <div class="arrow arrow--reverse">
          <img src="@/assets/img/chevron_up.svg" alt="svg">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import isIOS from '../../helpers/isIOS'

export default {
  name: 'StepTemperatureIncrease',
  props: {},

  components: {},

  data () {
    return {
      heatingNumber: -63,
      heatingEnd: 20,
    }
  },

  mounted () {
    if (this.$gtm) {
      this.$gtm.trackEvent({
        'event': 'Event',
        'analytics_action': this.$store.state.step + '-mounted',
        'analytics_label': this.$store.state.step,
      })
    }
  },

  created () {},

  updated () {},

  methods: {
    increaseHeating () {
      let increaseTo = this.heatingNumber + 22

      if (this.$gtm) {
        this.$gtm.trackEvent({
          'event': 'Event',
          'analytics_action': this.$store.state.step + '-button-increase-heating',
          'analytics_label': this.$store.state.step,
        })
      }

      let interval = setInterval(() => {
        if (this.heatingNumber < increaseTo && this.heatingNumber < this.heatingEnd) {
          this.heatingNumber++
        }
        else {
          clearInterval(interval)
        }
      }, 50)
    },

    next () {
      if (this.$gtm) {
        this.$gtm.trackEvent({
          'event': 'Event',
          'analytics_action': this.$store.state.step + '-increase-heating-done',
          'analytics_label': this.$store.state.step,
        })
      }

      this.$emit('next')
    },
  },

  watch: {
    heatingNumber (val) {
      if(val >= -20 && val <= this.heatingEnd) {
        if(!isIOS()) {
          this.$store.commit('setModel', 1)
        }
      }

      if (val >= this.heatingEnd) {
        if(!isIOS()) {
          this.$store.commit('setModel', 2)
        }

        setTimeout(() => {
          this.next()
        }, 3000)
      }
    },
  },

  computed: {
    ...mapState({
      step: state => state.step,
    }),
  },
}
</script>

<style lang="scss" scoped>

</style>
